// extracted by mini-css-extract-plugin
export default {"musicPlayer":"SoundPlayer_musicPlayer__AZchR"};